module.exports = __webpack_public_path__ + "Flag-296.ca931dae615f1b9dc309e99d4937430e.svg";